import { Directive, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FiBrowserEventsService } from '../fi-shared-services/fi-browser-events.service';

@Directive({
    selector: '[fiFitImage], [ccm-fit-image]',
    standalone: false,
})
export class FitImageDirective implements OnInit, OnDestroy {
    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
        private fiBrowserEventsService: FiBrowserEventsService,
    ) {}

    ngOnInit(): void {
        fromEvent(this.elementRef.nativeElement, 'load')
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe(() => this.resize());
        this.fiBrowserEventsService
            .getWindowEventSubject$('resize')
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe(() => this.resize());
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    private resize(): void {
        const element: HTMLElement = this.elementRef.nativeElement;
        let parentElement: HTMLElement = this.elementRef.nativeElement.parentElement;

        if (parentElement.localName === 'picture') parentElement = parentElement.parentElement;

        this.renderer.setStyle(
            element,
            'margin-left',
            element.offsetWidth > parentElement.offsetWidth
                ? -1 * ((element.offsetWidth - parentElement.offsetWidth) / 2) + 'px'
                : 0,
        );

        this.renderer.setStyle(
            element,
            'margin-top',
            element.offsetHeight > parentElement.offsetHeight
                ? -1 * ((element.offsetHeight - parentElement.offsetHeight) / 2) + 'px'
                : 0,
        );
    }
}
